import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareAttachmentsRoute: InvariantJiraRoute = {
	name: 'software-attachments',
	path: '/jira/:projectType(software|software/c)/projects/:projectKey/attachments',
};
